import React, { useState } from 'react';
import { formatCurrency, round2 } from '../utils/checkoutCalculations';

const PRESETS = [10, 15, 20];

/**
 * TipScreen
 * Percentage presets or custom amount, with cash/card toggle.
 */
const TipScreen = ({ state, actions, onBack, currencySymbol }) => {
  const fmt = (amount) => formatCurrency(amount, currencySymbol);
  const subtotal = state.subtotal - state.discountTotal;

  const existing = state.tip;
  const [tipType, setTipType] = useState(existing?.type || 'card');
  const [mode, setMode] = useState('percentage');
  const [percentValue, setPercentValue] = useState(0);
  const [customAmount, setCustomAmount] = useState(existing?.amount > 0 ? String(existing.amount) : '');
  const [customActive, setCustomActive] = useState(existing?.amount > 0);

  // Calculate tip amount
  let tipAmount = 0;
  if (mode === 'percentage' && percentValue > 0) {
    tipAmount = round2(subtotal * (percentValue / 100));
  } else if (customActive || mode === 'custom') {
    const parsed = parseFloat(customAmount);
    if (!isNaN(parsed) && parsed > 0) {
      tipAmount = round2(parsed);
    }
  }

  const selectPreset = (p) => {
    setPercentValue(percentValue === p ? 0 : p);
    setCustomActive(false);
    setMode('percentage');
  };

  const handleApply = () => {
    if (tipAmount > 0) {
      actions.setTip({ amount: tipAmount, type: tipType });
    }
    onBack();
  };

  const handleSkip = () => {
    actions.setTip({ amount: 0, type: null });
    onBack();
  };

  const handleRemove = () => {
    actions.setTip({ amount: 0, type: null });
    onBack();
  };

  return (
    <div className="co-discount">
      <div className="co-screen-header">
        <button className="co-back-btn" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h2 className="co-screen-title">Add Tip</h2>
      </div>

      {/* Cash / Card toggle */}
      <div className="co-discount-toggle">
        <button className={`co-discount-toggle-btn ${tipType === 'card' ? 'co-discount-toggle-btn--active' : ''}`} onClick={() => setTipType('card')}>
          Card Tip
        </button>
        <button className={`co-discount-toggle-btn ${tipType === 'cash' ? 'co-discount-toggle-btn--active' : ''}`} onClick={() => setTipType('cash')}>
          Cash Tip
        </button>
      </div>

      <div className="co-discount-body">
        {/* Percentage presets */}
        <div className="co-discount-presets">
          {PRESETS.map(p => (
            <button
              key={p}
              className={`co-discount-chip ${percentValue === p && !customActive ? 'co-discount-chip--active' : ''}`}
              onClick={() => selectPreset(p)}
            >
              {p}%
            </button>
          ))}
          <button
            className={`co-discount-chip ${customActive ? 'co-discount-chip--active' : ''}`}
            onClick={() => { setCustomActive(true); setPercentValue(0); setMode('custom'); }}
          >
            Custom
          </button>
        </div>

        {/* Custom amount input */}
        {customActive && (
          <div className="co-discount-fixed-row" style={{ marginTop: 12 }}>
            <span className="co-discount-fixed-symbol">{currencySymbol}</span>
            <input
              type="number"
              className="co-discount-fixed-input"
              placeholder="0.00"
              step="0.01"
              min="0"
              value={customAmount}
              onChange={e => setCustomAmount(e.target.value)}
              autoFocus
            />
          </div>
        )}

        {/* Preview */}
        <div className="co-discount-preview">
          <div className="co-discount-preview-row">
            <span>Service total</span>
            <span>{fmt(subtotal)}</span>
          </div>
          {tipAmount > 0 && (
            <div className="co-discount-preview-row" style={{ color: '#6366f1', fontWeight: 500 }}>
              <span>Tip ({tipType === 'cash' ? 'Cash' : 'Card'}){mode === 'percentage' ? ` (${percentValue}%)` : ''}</span>
              <span>+{fmt(tipAmount)}</span>
            </div>
          )}
          <div className="co-discount-preview-row co-discount-preview-row--total">
            <span>New Total</span>
            <span>{fmt(subtotal + tipAmount)}</span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="co-pl-footer">
        {existing?.amount > 0 ? (
          <>
            <button className="bdp-btn bdp-btn--secondary" style={{ color: '#ef4444' }} onClick={handleRemove}>
              Remove
            </button>
            <button className="bdp-btn bdp-btn--primary" onClick={handleApply} disabled={tipAmount <= 0}>
              Update Tip
            </button>
          </>
        ) : (
          <>
            <button className="bdp-btn bdp-btn--secondary" onClick={handleSkip}>
              No Tip
            </button>
            <button className="bdp-btn bdp-btn--primary" onClick={handleApply} disabled={tipAmount <= 0}>
              Add Tip
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default TipScreen;
